"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedFolders = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var Loading_1 = require("./components/Loading");
var FolderList_1 = require("./components/FolderList");
var ErrorHandling_1 = require("./components/ErrorHandling");
var dispatchers_1 = require("./utils/dispatchers");
var listData_1 = require("./utils/listData");
var list_1 = require("utils/list");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var getState = function (state) { return state.vektorio.linkedFolders; };
var LinkedFolders = function (props) {
    var state = (0, react_redux_1.useSelector)(getState);
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var _a = React.useState(0), contentWidth = _a[0], setContentWidth = _a[1];
    var _b = React.useState({}), columns = _b[0], setColumns = _b[1];
    var _c = React.useState([]), items = _c[0], setItems = _c[1];
    var style = React.useState({})[0];
    React.useEffect(function () {
        var _a = (0, list_1.mapData)({
            columns: (0, listData_1.initColumns)(),
            items: state.linkedFolders,
            filterOptions: state.filterOptions,
            orderByOptions: state.orderByOptions
        }), contentWidth = _a.contentWidth, columns = _a.columns, items = _a.items;
        setItems(items);
        setColumns(columns);
        setContentWidth(contentWidth);
    }, [state.linkedFolders, state.filterOptions, state.orderByOptions]);
    var listData = {
        columns: columns,
        items: items
    };
    var headerData = {
        columns: columns,
        style: style,
        orderByOptions: state.orderByOptions,
        filterOptions: state.filterOptions,
        sortBy: dispatchers.sortBy,
        filterBy: dispatchers.filterBy
    };
    return (React.createElement("div", { className: 'vektorio-linked-folders-list-container' },
        React.createElement("div", { className: 'sok-list-content vektorio-linked-folders-list' },
            state.status.isFailure && React.createElement(ErrorHandling_1.ErrorHandling, { fetch: props.fetch }),
            state.status.isBusy && React.createElement(Loading_1.Loading, null),
            state.status.isSuccess && listData.items.length > 0 ? (React.createElement(FolderList_1.FolderList, { listData: listData, headerData: headerData, contentWidth: contentWidth })) : (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: "vektorio/emptyList/message/linked/Folders/title", message: (0, translation_1.getLocalization)('vektorio/emptyList/linked/Folders/message') })))));
};
exports.LinkedFolders = LinkedFolders;
